import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";


interface GeneroState {
    status: string;
    error: string;
    generoList: any[],
    generoListActive: any[],
    genero: {
        idGenero: number | null;
        nombre: string | null;
    }

}

const initialState: GeneroState = {
    status: 'idle',
    error: '',
    generoList: [],
    generoListActive: [],
    genero: {
        idGenero: null,
        nombre: null
    }
}

export const fetchGenero = createAsyncThunk('fetchGenero', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 33;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchGeneroActive = createAsyncThunk('fetchGeneroActive', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    
    const idsp = 34;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});


export const generoSlice = createSlice({
    name: 'genero',
    initialState,
    reducers: {
        setGeneroList: (state, action) => {
            state.generoList = action.payload;
        },
        setGeneroListActive: (state, action) => {
            state.generoListActive = action.payload;
        },
        setGenero: (state, action) => {
            state.genero = !action.payload ? initialState.genero : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchGenero.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchGenero.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.generoList = data ? data : [];

            })
            .addCase(fetchGenero.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchGeneroActive.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchGeneroActive.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.generoListActive = data ? data : [];

            })
            .addCase(fetchGeneroActive.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectGeneroList = (state: RootState) => state.genero.generoList;
export const selectGeneroListActive = (state: RootState) => state.genero.generoListActive;
export const selectGenero = (state: RootState) => state.genero.genero;

export const { setGeneroList, setGeneroListActive, setGenero } = generoSlice.actions;

export default generoSlice.reducer;



